
<!-- https://github.com/jkuri/ng2-datepicker/tree/master/src/ng2-datepicker-->
<div class="datepicker-calendar" *ngIf="opened">
  <div class="datepicker-calendar-top"><span class="year-title">{{ currentDate.format('YYYY') }}</span>
    <button type="button" (click)="openYearPicker()" *ngIf="!yearPicker">{{ options.selectYearText }}</button><i class="close oi oi-x" (click)="close()"></i>
  </div>
  <div class="datepicker-calendar-container">
    <div *ngIf="!yearPicker &amp;&amp; !monthPicker">
      <div class="datepicker-calendar-month-section"><i class="oi oi-chevron-left" (click)="prevMonth()"></i>
        <button class="month-title" type="button" (click)="openMonthPicker()">{{ currentDate.format('MMMM') }}</button><i class="oi oi-chevron-right" (click)="nextMonth()"></i>
      </div>
      <div class="datepicker-calendar-day-names"><span *ngFor="let d of weekdaysText">{{ d }}</span></div>
      <div class="datepicker-calendar-days-container"></div>
      <div class="datepicker-calendar-days-container"><span *ngFor="let d of days; let i = index" (click)="selectDate($event, d.momentObj)" [ngClass]="{day: true, disabled: !d.enabled, today: d.today, selected: d.selected}">{{ d.day }}</span></div>
      <div class="row mt-2" *ngIf="!options.autoApply">
        <div class="col">
          <button class="btn btn-outline-secondary btn-block" type="button" (click)="clearDate()">{{ options.clearText }}</button>
        </div>
        <div class="col">
          <button class="btn btn-primary btn-block" type="button" (click)="today()">{{ options.todayText }}</button>
        </div>
      </div>
    </div>
    <div *ngIf="monthPicker">
      <div class="datepicker-calendar-months-container"><span class="month" *ngFor="let m of months" (click)="selectMonth($event, m.index)" [ngClass]="{disabled: !m.enabled, today: m.today, selected: m.selected}">{{ m.month }}</span></div>
    </div>
    <div *ngIf="yearPicker">
      <div class="datepicker-calendar-years-container" slimScroll [options]="scrollOptions"><span class="year" *ngFor="let y of years; let i = index" (click)="selectYear($event, y)">{{ y }}</span></div>
    </div>
  </div>
</div>
<button class="btn btn-primary oi oi-calendar" type="button" (click)="toggle()"></button>